import dayjs from 'lib/date/dayjs';

export function formatTimestamp(timestamp: string | number | null | undefined): string {
  if (!timestamp) {
    return '';
  }

  return dayjs(timestamp).fromNow();
}

export function formatTimestampFull(timestamp: string | number | null | undefined): string {
  if (!timestamp) {
    return '';
  }

  return dayjs(timestamp).format('MMM DD, YYYY HH:mm:ss');
}
